import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentIndex: null
};

export const hamburgerSlice = createSlice({
    name: "hamburger",
    initialState,
    reducers: {
        setCurrentIndex: (state, { payload }) => {
            return {
                ...state,
                currentIndex: payload
            }
        }

    },
});

export const { setCurrentIndex } = hamburgerSlice.actions;
export default hamburgerSlice.reducer;